import { ShieldCheck } from 'lucide-react';

/**
 * Static guidance chips shown under the symptom/needs description field to
 * prompt the patient on what to mention. Display-only (no interaction).
 */
export function SymptomHints({ hints }: { hints: string[] }) {
  return (
    <div className="flex flex-wrap gap-2">
      {hints.map((hint) => (
        <span
          key={hint}
          className="rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs text-gray-600"
        >
          {hint}
        </span>
      ))}
    </div>
  );
}

/** Reassurance note rendered just above the form's call-to-action buttons. */
export function PrivacyNote({ text }: { text: string }) {
  return (
    <div className="flex items-center justify-center gap-1.5 text-xs text-gray-500">
      <ShieldCheck className="h-4 w-4 text-green-600" />
      <span>{text}</span>
    </div>
  );
}
